<template>
  <IadWrapper inner-classes="flex flex-col gap-l">
    <IadTitle
      tag="p"
      variant="large"
      :text="$t(`agent.valuation.objectives.title`)"
    />
    <IadScrollable variant="dense">
      <li class="flex flex-col gap-l item-center text-center border border-neutral-60 overflow-clip relative rounded-xl p-l">
        <span class="flex justify-center items-center self-center bg-secondary-70 rounded-full size-28 font-semibold text-7xl">
          <Icon name="iad-icon:sell" />
        </span>
        <div class="flex flex-col gap-s">
          <IadTitle
            variant="x-small"
            tag="p"
            :text="$t('agent.valuation.objectives.first_step.title')"
          />
          <label v-text="$t('agent.valuation.objectives.first_step.description')" />
        </div>
      </li>
      <li class="flex flex-col gap-l item-center text-center border border-neutral-60 overflow-clip relative rounded-xl p-l">
        <span class="flex justify-center items-center self-center bg-secondary-70 rounded-full size-28 font-semibold text-7xl">
          <Icon name="iad-icon:star-outlined" />
        </span>
        <div class="flex flex-col gap-s">
          <IadTitle
            variant="x-small"
            tag="p"
            :text="$t('agent.valuation.objectives.second_step.title')"
          />
          <label v-text="$t('agent.valuation.objectives.second_step.description')" />
        </div>
      </li>
      <li class="flex flex-col gap-l item-center text-center border border-neutral-60 overflow-clip relative rounded-xl p-l">
        <span class="flex justify-center items-center self-center bg-secondary-70 rounded-full size-28 font-semibold text-7xl">
          <Icon name="iad-icon:visibility" />
        </span>
        <div class="flex flex-col gap-s">
          <IadTitle
            variant="x-small"
            tag="p"
            :text="$t('agent.valuation.objectives.third_step.title')"
          />
          <label v-text="$t('agent.valuation.objectives.third_step.description')" />
        </div>
      </li>
      <li class="flex flex-col gap-l item-center text-center border border-neutral-60 overflow-clip relative rounded-xl p-l">
        <span class="flex justify-center items-center self-center bg-secondary-70 rounded-full size-28 font-semibold text-7xl">
          <Icon name="iad-icon:handshake" />
        </span>
        <div class="flex flex-col gap-s">
          <IadTitle
            variant="x-small"
            tag="p"
            :text="$t('agent.valuation.objectives.fourth_step.title')"
          />
          <label v-text="$t('agent.valuation.objectives.fourth_step.description')" />
        </div>
      </li>
    </IadScrollable>
  </IadWrapper>
</template>
